import { useState, useCallback, useEffect } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useGetDealSubCampaigns = (dealId) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [subCampaigns, setSubCampaigns] = useState([]);

    const getDealSubCampaigns = useCallback(async () => {
        if (!dealId) {
            toast.error("Deal ID is required.");
            return;
        }

        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "getDealSubCampaigns",
                dealId: dealId,
            });
            setSubCampaigns(response.data.subCampaigns || []);
            return response.data.subCampaigns;
        } catch (err) {
            toast.error(apiErrorText(err));
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    }, [dealId]);

    useEffect(() => {
        if (dealId) {
            getDealSubCampaigns();
        }
    }, [dealId, getDealSubCampaigns]);

    return { loading, error, subCampaigns, getDealSubCampaigns };
};

export default useGetDealSubCampaigns;
